// settings views
const SettingsMenu = () => import("Core/configuration/configuration_menu/views/SettingsMenu");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/:tab(\\d+)?",
            name: "configuration",
            component: SettingsMenu,
            meta: {
                requiresAuth: true,
                title: "lang.configuration",
                loader: false,
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
